module.exports = __webpack_public_path__ + "img/beach.647143c7.jpg";